import "./App.css";

function ExternalLinks() {

    return (
        <div>

            <a className="footer-link fa fa-linkedin-square" href="https://www.linkedin.com/in/leowginee/" title="LinkedIn" target="_blank" rel="noopener noreferrer"> </a>
            <a className="footer-link fa fa-pencil-square" href="https://my-datascience-app.herokuapp.com/" title="Portfolio App" target="_blank" rel="noopener noreferrer"> </a>
            <a className="footer-link fa fa-github" title="GitHub" href="https://github.com/gin-ee" target="_blank" rel="noopener noreferrer"> </a>
            <a className="footer-link fa fa-bar-chart" title="Tableau Public" href="https://public.tableau.com/app/profile/leowginee" target="_blank" rel="noopener noreferrer"> </a>

        </div>
    );
};

export default ExternalLinks;